import { Event } from "../../../../Global/Base/Events";
import { IDisposable } from "../../../../Global/Base/IDisposable";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { Control } from "./Control";
import { ControlParams } from "./ControlInterfaces";

/**
 * Parametry konstruktoru tridy {@link GenericPage}.
 */
export type GenericPageParams = ControlParams & {
    header: GenericPageTab;
};

/**reprezentuje zalozku*/
export class GenericPage extends Control {
    //#region Fields
    public header: GenericPageTab;
    protected _selected: boolean;
    //#endregion Fields

    //#region Properties
    public get selected(): boolean {
        return this._selected;
    }

    public set selected(value: boolean) {
        this._selected = value;
        if (!value)
            this.element.classList.remove("active");
        else
            this.element.classList.add("active");
    }

    public get isVisible(): boolean {
        //return this.Header.Element.style.display != "none";
        return this._visible;
    }
    //#endregion Properties

    //#region Contructors
    constructor(params: GenericPageParams) {
        super(params);

        this.header = params.header;
    }
    //#endregion Contructors

    //#region Methods
    public hide(): void {
        this._visible = false;
        this.header.visible = false;
        this.element.style.display = "none";
    }

    public show(): void {
        this._visible = true;
        this.header.visible = true;
        this.element.style.display = "";
    }

    public initPage(): void {
        this.element.classList.add("Page");
        this.header.element.classList.add("tab");
    }

    //#endregion Methods
}

/**reprezentuje ousko zalozky*/
export class GenericPageTab implements IDisposable {
    //#region Events
    public tabSelected: Event<GenericPageTab, MouseEvent> = new Event<GenericPageTab, MouseEvent>();
    //#endregion Events

    //#region Fields
    public element: HTMLLIElement;

    // @ts-ignore // nečteno, ale ponecháno
    private _listenerClick: EventListener;

    private _selected: boolean;
    private _selectAfterShow: boolean = false;
    private _visible: boolean = true;
    //#endregion Fields

    //#region Properties
    public get visible(): boolean {
        return this._visible;
    }

    public set visible(value: boolean) {
        if (this.element == undefined)
            return;

        this._visible = value;

        if (this._visible) {
            this.element.style.display = "";
            if (this._selectAfterShow)
                this.selected = true;
        } else {
            this.element.style.display = "none";
        }
    }

    public get selected(): boolean {
        return this._selected;
    }

    public set selected(value: boolean) {
        this._selectAfterShow = false;
        if (!value || !this.visible) {
            if (value) //Pokud neni zalozka videt, tak nastavim priznak, aby se pri zviditelneni vybrala.
                this._selectAfterShow = true;
            this._selected = false;
            this.element.classList.remove("active");
        } else {
            this._selected = true;
            this.element.classList.add("active");
            this.tabSelected.trigger(this, null);
        }
    }
    //#endregion Properties

    //#region Constructors
    constructor(tabName: string, locKey: string) {
        this.element = document.createElement("li");
        this.element.classList.add("tab");

        this.element.addEventListener("click", this._listenerClick = (evn) => {
            this.tabClick(evn as MouseEvent);
        });

        const x: HTMLDivElement = document.createElement("div");

        Localization.addLocTxtData(x, locKey);
        if (!locKey)
            x.textContent = tabName;

        this.element.appendChild(x);
    }
    //#endregion Constructors

    public tabClick(_envt: MouseEvent): void {
        if (this.selected)
            return;

        this.selected = true;
    }

    public dispose(): void {
        // Prázdná metoda
    }
}
